import { HelpIcon } from '@common_components/icons/help.icon';
import React from 'react';
import { Tooltip } from 'react-tooltip';

interface InfoTooltipProps {
  label: string;
  tooltip: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ( { label, tooltip } ) => {
  return (
    <>
      <div id={label} className="inline-block text-gray-500">
        <HelpIcon size={7} />
      </div>
      <Tooltip anchorSelect={ '#' + label } className="z-[100]" place="right">
        {tooltip}
      </Tooltip>
    </>
  );
};

export default InfoTooltip;
